// @greenlight-spec: 08-app-deployment.md#deploy-state-machine
// @greenlight-spec: 11-observability.md#pod-diagnostics
// @greenlight-spec: 16-api-conventions.md
import { z } from 'zod';
/**
 * Cluster-autoscaler Event reasons that mean app-node capacity will NOT arrive on
 * its own: the autoscaler declined to scale (`NotTriggerScaleUp`) or a scale-up
 * attempt failed (`FailedScaleUp`). Single source for the blocker classifier, the
 * capacity provider read, and the health assessment.
 */
export const AUTOSCALER_NO_CAPACITY_REASONS = ['NotTriggerScaleUp', 'FailedScaleUp'];
/**
 * Who must act on a stuck rollout — the one field anything branches on. `operator`
 * means a platform capacity/routing problem the agent cannot fix by changing app
 * code: the agent must stop editing app code. `agent` means an app-code/manifest
 * fix. `unknown` when the evidence does not pin it down.
 */
export const ROLLOUT_BLOCKER_OWNERS = ['operator', 'agent', 'unknown'];
/**
 * Why a rollout did not become available, persisted on the failed `deploy` check
 * and surfaced through `getPipelineRun` (and `getAppDiagnostics` once it lands).
 * Just two fields: `owner` is the machine-readable signal (whose problem it is);
 * `message` is one self-contained line carrying everything a human/agent reads —
 * what failed, the underlying scheduler/controller reason, the pod/container when
 * known, and what to do. It is secret-free.
 */
export const RolloutBlockerSchema = z.object({
    owner: z.enum(ROLLOUT_BLOCKER_OWNERS),
    message: z.string(),
});
//# sourceMappingURL=rollout-blocker.js.map